import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    window.Poetry?.colorScheme?.toggle()
  }
}
